import RestUtilities from '../services/RestUtilities';


export default class AuthServices {

static async signin(formData ){

    return await RestUtilities.postNoAuth(
        'usuario/loginuser', formData).then((response) => {
            if (!response.is_error)
             {
                window.localStorage.setItem('profile', JSON.stringify( response.result ));
            }
            return response;
            });
 
}

static async signup (formData)  {
    try {
    /*    const {data} = await api.signUp(formData);

        dispatch({ type: AUTH, data });
*/

    } catch (error) {
        console.log(error);
    }
}
/*
static async isTokenExpired() {
    const token = this.getToken();
    if (!token) {
      return true;
    }

    const expirationDate = decode(token).exp;
    return expirationDate < Date.now() / 1000;
  }
*/

static async getAuthenticatedUser() {

}

static async logout() {
  window.localStorage.clear();
};

}